module.exports = __webpack_public_path__ + "static/media/facebook.8ab99b7b.svg";